import { render, staticRenderFns } from "./DisclaimerAndAssumptionsPage.vue?vue&type=template&id=29f4e0ff"
import script from "./DisclaimerAndAssumptionsPage.vue?vue&type=script&lang=js"
export * from "./DisclaimerAndAssumptionsPage.vue?vue&type=script&lang=js"
import style0 from "./DisclaimerAndAssumptionsPage.vue?vue&type=style&index=0&id=29f4e0ff&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports